export const getCurrentCompanyAddresses = (state) => state.permissions.current.company.addresses
